<div class="row">
  <div class="col-md-12">
    <nb-card>
      <nb-card-header>{{ 'tytul.moje-konto' | translate }}</nb-card-header>
      <nb-card-body>        

        <nb-tabset>
          <nb-tab tabTitle="{{ 'zakladka.zmiana-hasla' | translate }}">
            <ngx-zmiana-hasla></ngx-zmiana-hasla>
          </nb-tab>
        </nb-tabset>
      </nb-card-body>
    </nb-card>
  </div>
</div>
